<h1 mat-dialog-title>{{'subscription.form.validationReclamation.title' | translate}}</h1>
<mat-dialog-content>
   
  <div>
    <p>En date des présentes, avez-vous connaissance d’une RÉCLAMATION qui n’aurait pas déjà été rapportée au Fonds? Une RÉCLAMATION signifie :</p>
    <br>
    <p>1. toute demande visant l’octroi de <b>Dommages</b> en raison d’une faute commise dans le cadre de vos <b>Services professionnels;</b> </p>
    <p>2. tout reproche ayant trait à la qualité de vos <b>Services professionnels</b> pouvant raisonnablement suggérer qu’une demande visant l’octroi de <b>Dommages</b> pourrait vous être présentée; ou </p>
    <p>3. tous faits et circonstances raisonnablement susceptibles de donner lieu à une demande visant l’octroi de <b>Dommages</b> en raison d’une faute commise dans le cadre de vos <b>Services professionnels</b> .</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end">
  <button  mat-raised-button
          (click)="yesAnswer()">
          {{'subscription.yesButton' | translate}}</button>
  <button color="primary"
          mat-raised-button
          (click)="noAnswer()">
          {{'subscription.noButton' | translate}}</button>  
</mat-dialog-actions>
